import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MenuState } from '../reducers/menu.reducer';

export const menuState: any = createFeatureSelector<MenuState>('menu');

export const collapsedMenu = createSelector(menuState, (state: any) => state.collapsedMenu);

export const menuData = createSelector(menuState, (state: any) => {
  return state.menuData;
});

export const toggleSideBar = createSelector(menuState, (state: any) => state.toggleSideBar);
